class ProductComparisonDrawer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Store for selected products
    this.selectedProducts = [];

    this.content = this.querySelector('.product-comparison-drawer__content');
    this.items = this.querySelector('.product-comparison-drawer__items');
    this.buttons = this.querySelector('.product-comparison-drawer__buttons');
    this.clearAllButton = this.querySelector('.product-comparison-drawer__clear-all');

    // Check for existing selections (from localStorage or URL params)
    this.loadSavedSelections();
    this.populateCardsFromSavedSelections();

    // Use event delegation to handle dynamically loaded checkboxes
    document.addEventListener('change', (event) => {
      if (event.target.classList.contains('compare-checkbox')) {
        const checkbox = event.target;
        const checkboxId = checkbox.dataset.id;
        
        if (checkbox.checked) {
          // Show alert if user tries to add more than 5 products
          if (this.selectedProducts.length >= 5) {
            alert('Compare is limited to 5 selections, please remove an item from the compare list before adding another item.');
            checkbox.checked = false;
            return;
          }

          this.compareDrawerVisibility(true);
          this.createCompareCard(checkbox);
        } else {
          this.removeCompareCard(document.querySelector(`.product-comparison-drawer__card[data-product-id="${checkboxId}"] .product-comparison-drawer__card-remove`));
        }
      }
    });

    this.clearAllButton.addEventListener('click', () => {
      this.removeAllCompareCards();
    });
  }

  addProductToComparison(product) {
    // Check if product is already in the list
    if (this.selectedProducts.some(p => p.handle === product.handle)) {
      return;
    }
    
    // Add to selected products array
    this.selectedProducts.push(product);

    // Save selections
    this.saveSelections();
  }

  updateCompareDrawerButtonUrl() {
    const compareDrawerButton = this.querySelector('.product-comparison-drawer__compare-all');
    const compareDrawerButtonUrl = this.selectedProducts.map(p => p.handle).join(',');
    compareDrawerButton.href = `/pages/compare?compare=${compareDrawerButtonUrl.toString()}`;
  }

  // Flexible method to extract product data from either product card or PDP context
  extractProductData(checkboxChecked) {
    // Get product ID from checkbox data attribute
    const productId = checkboxChecked.dataset.id;

    // Try to find product card context first
    const productCard = checkboxChecked.closest('.card-product');
    
    if (productCard) {
      // Product card context
      return this.extractFromProductCard(productCard, productId);
    } else {
      // PDP/buybox context
      return this.extractFromPDP(productId);
    }
  }

  // Extract data from product card
  extractFromProductCard(productCard, productId) {
    const productLink = productCard.querySelector('.card-product__inner');
    const productHandle = productLink ? productLink.getAttribute('href').split('/').pop() : '';
    const productImageEl = productCard.querySelector('.card-product__image');
    const storeLogo = this.dataset.storeLogo;
    const productImage = productImageEl ? productImageEl.src : storeLogo;
    const productTitle = productCard.querySelector('.card-product__title')?.textContent.trim() || '';

    return {
      productId,
      productHandle,
      productImage,
      productTitle
    };
  }

  // Extract data from PDP/buybox context
  extractFromPDP(productId) {
    const productHandle = window.location.pathname.split('/').pop();
    const productTitle = document.querySelector('.product-buy-box__title').textContent.trim();
    const productImageEl = document.querySelector('.product-media-gallery__main-slide img');
    const storeLogo = this.dataset.storeLogo;
    const productImage = productImageEl ? productImageEl.src : storeLogo;

    return {
      productId,
      productHandle,
      productImage,
      productTitle
    };
  }

  compareDrawerVisibility(showDrawer) {
    if (showDrawer) {
      this.showCompareDrawer();
    } else {
      this.hideCompareDrawer();
    }
  }

  createCompareCard(checkboxChecked) {
    // Extract product data using flexible method
    const productData = this.extractProductData(checkboxChecked);
    const { productId, productHandle, productImage, productTitle } = productData;
    
    // Add product to comparison
    this.addProductToComparison({
      handle: productHandle,
      image: productImage,
      title: productTitle,
      id: productId
    });

    const compareCard = `<div class="product-comparison-drawer__card" data-product-id="${productId}">
      <button class="product-comparison-drawer__card-remove">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9238 12.7442C14.2496 13.0701 14.2496 13.5967 13.9238 13.9226C13.7613 14.0851 13.548 14.1667 13.3346 14.1667C13.1213 14.1667 12.908 14.0851 12.7455 13.9226L10.0013 11.1784L7.25714 13.9226C7.09464 14.0851 6.8813 14.1667 6.66797 14.1667C6.45464 14.1667 6.2413 14.0851 6.0788 13.9226C5.75297 13.5967 5.75297 13.0701 6.0788 12.7442L8.82297 10.0001L6.0788 7.25592C5.75297 6.93008 5.75297 6.40342 6.0788 6.07758C6.40464 5.75175 6.9313 5.75175 7.25714 6.07758L10.0013 8.82175L12.7455 6.07758C13.0713 5.75175 13.598 5.75175 13.9238 6.07758C14.2496 6.40342 14.2496 6.93008 13.9238 7.25592L11.1796 10.0001L13.9238 12.7442ZM10.0013 1.66675C5.4063 1.66675 1.66797 5.40508 1.66797 10.0001C1.66797 14.5951 5.4063 18.3334 10.0013 18.3334C14.5963 18.3334 18.3346 14.5951 18.3346 10.0001C18.3346 5.40508 14.5963 1.66675 10.0013 1.66675V1.66675Z" fill="#8F9296"/>
      </svg>
      </button>
      <div class="product-comparison-drawer__card-image">
        <img src="${productImage}" alt="${productTitle}" width="50" height="50">
      </div>
    </div>`;

    this.items.insertAdjacentHTML('beforeend', compareCard);

    this.updateCompareCount();

    // Add event listener only to the newly created remove button
    const newCard = this.items.lastElementChild;
    const newRemoveButton = newCard.querySelector('.product-comparison-drawer__card-remove');
    newRemoveButton.addEventListener('click', (event) => this.removeCompareCard(event.target));

    this.updateCompareDrawerButtonUrl();
  }

  removeCompareCard(button) {
    const card = button.closest('.product-comparison-drawer__card');
    const productId = card.dataset.productId;

    // Update checkbox checked state
    const checkboxChecked = document.querySelector(`input[data-id="${productId}"]`);
    if (checkboxChecked) checkboxChecked.checked = false;

    this.removeProductFromComparison(productId);

    // Remove card from Compare Drawer
    card.remove();

    // Update compare count
    this.updateCompareCount();

    // Hide drawer if no items left
    if (this.items.querySelectorAll('.product-comparison-drawer__card').length === 0) {
      this.hideCompareDrawer();
    }

    this.updateCompareDrawerButtonUrl();
  }

  removeAllCompareCards() {
    // Get all cards in the drawer
    const allCards = this.items.querySelectorAll('.product-comparison-drawer__card');
    
    // Iterate through all cards and remove each one
    allCards.forEach(card => {
      const removeButton = card.querySelector('.product-comparison-drawer__card-remove');
      if (removeButton) {
        this.removeCompareCard(removeButton);
      }
    });
  }

  updateCompareCount() {
    const compareCount = this.querySelector('.product-comparison-drawer__count');
    const compareCountValue = this.items.querySelectorAll('.product-comparison-drawer__card').length;

    compareCount.textContent = compareCountValue > 0 ? `(${compareCountValue})` : '';
  }

  hideCompareDrawer() {
    this.classList.remove('is-visible');
  }

  showCompareDrawer() {
    this.classList.add('is-visible');
  }

  removeProductFromComparison(productHandle) {
    // Remove from selected products array
    this.selectedProducts = this.selectedProducts.filter(p => p.id !== productHandle);

    // Save selections
    this.saveSelections();
  }

  findCheckboxByHandle(productHandle) {
    if (window.location.pathname.split('/').pop() == productHandle) {
      return document.querySelector('.compare-checkbox');
    }

    // Find all product cards
    const productCards = document.querySelectorAll('card-product');
    
    // Loop through each card to find the one with matching handle
    for (const card of productCards) {
      const cardLink = card.querySelector('.card-product__inner');
      if (!cardLink) continue;
      
      const cardHandle = cardLink.getAttribute('href').split('/').pop();
      if (cardHandle === productHandle) {
        return card.querySelector('.compare-checkbox');
      }
    }
    
    return null;
  }

  populateCardsFromSavedSelections() {
    const savedSelections = localStorage.getItem('selectedProductsForComparison');
    if (savedSelections) {
      this.selectedProducts = JSON.parse(savedSelections);
      this.selectedProducts.forEach(product => {
        // Add product to comparison
        this.addProductToComparison({
          handle: product.handle,
          image: product.image,
          title: product.title,
          id: product.id
        });

        const compareCard = `<div class="product-comparison-drawer__card" data-product-id="${product.id}">
          <button class="product-comparison-drawer__card-remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9238 12.7442C14.2496 13.0701 14.2496 13.5967 13.9238 13.9226C13.7613 14.0851 13.548 14.1667 13.3346 14.1667C13.1213 14.1667 12.908 14.0851 12.7455 13.9226L10.0013 11.1784L7.25714 13.9226C7.09464 14.0851 6.8813 14.1667 6.66797 14.1667C6.45464 14.1667 6.2413 14.0851 6.0788 13.9226C5.75297 13.5967 5.75297 13.0701 6.0788 12.7442L8.82297 10.0001L6.0788 7.25592C5.75297 6.93008 5.75297 6.40342 6.0788 6.07758C6.40464 5.75175 6.9313 5.75175 7.25714 6.07758L10.0013 8.82175L12.7455 6.07758C13.0713 5.75175 13.598 5.75175 13.9238 6.07758C14.2496 6.40342 14.2496 6.93008 13.9238 7.25592L11.1796 10.0001L13.9238 12.7442ZM10.0013 1.66675C5.4063 1.66675 1.66797 5.40508 1.66797 10.0001C1.66797 14.5951 5.4063 18.3334 10.0013 18.3334C14.5963 18.3334 18.3346 14.5951 18.3346 10.0001C18.3346 5.40508 14.5963 1.66675 10.0013 1.66675V1.66675Z" fill="#8F9296"/>
          </svg>
          </button>
          <div class="product-comparison-drawer__card-image">
            <img src="${product.image}" alt="${product.title}" width="50" height="50">
          </div>
        </div>`;

        this.items.insertAdjacentHTML('beforeend', compareCard);

        this.updateCompareCount();

        // Add event listener only to the newly created remove button
        const newCard = this.items.lastElementChild;
        const newRemoveButton = newCard.querySelector('.product-comparison-drawer__card-remove');
        newRemoveButton.addEventListener('click', (event) => this.removeCompareCard(event.target));
      });
    }
  }

  saveSelections() {
    localStorage.setItem('selectedProductsForComparison', JSON.stringify(this.selectedProducts));
  }
  
  loadSavedSelections() {
    const savedSelections = localStorage.getItem('selectedProductsForComparison');
    if (savedSelections) {
      this.selectedProducts = JSON.parse(savedSelections);
      
      // Check corresponding checkboxes
      this.selectedProducts.forEach(product => {
        const checkbox = this.findCheckboxByHandle(product.handle);
        if (checkbox) checkbox.checked = true;
      });

      if (this.selectedProducts.length > 0) {
        this.compareDrawerVisibility(true);
      } else {
        this.compareDrawerVisibility(false);
      }

      // Update Compare Drawer Button Url
      this.updateCompareDrawerButtonUrl();
    }
  }
}

customElements.define('product-comparison-drawer', ProductComparisonDrawer);
